import React, { useState } from 'react';
import Header from '../Header/Header';
import './AddService.css'
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { createReactEditorJS } from 'react-editor-js';
import { EDITOR_JS_TOOLS } from './tools'
import slugify from 'slugify';

const AddService = () => {

    const ReactEditorJS = createReactEditorJS()

    const [image, setImage] = useState(null)
    const [gigImage, setGigImage] = useState(null)
    const [description, setDescription] = useState([])




    let url;

    if (image) {
        url = URL.createObjectURL(image)
    }




    const handleAddService = (e) => {
        e.preventDefault()
        const titleField = document.getElementById('mui-1')
        const title = titleField?.value

        const slug = slugify(title)



        const formData = new FormData()

        formData.append('title', title)
        formData.append('thumbnail', image)
        formData.append('slug', slug)
        formData.append('description', JSON.stringify(description))




        fetch('http://localhost:8080/services', {
            method: "POST",
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                window.alert('Added Success')
            })

    }


    return (
        <div id='addService'>
            <Header></Header>
            <div className="container mt-5">
                <div className="form-container flex-column d-flex align-items-center justify-content-center">
                    <div className="form-title">
                        <h3 className='heading-title'>Add Your Service</h3>
                    </div>
                    <div className="box w-100">


                        {/* form */}

                        <form onSubmit={handleAddService}>
                            <Box
                                component="div"
                                sx={{
                                    '& .MuiTextField-root': { m: 1, width: '100%' },
                                }}
                                noValidate
                                autoComplete="off"
                            >

                                {/* title field */}

                                <div className="row">
                                    <div className="col">
                                        <div>
                                            <TextField
                                                required
                                                label="Title"
                                                placeholder="Enter a good title"
                                                variant="standard"
                                                type="text"
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Description Box */}

                                <div className="description">
                                    <label style={{
                                        fontSize: '2rem'
                                    }}>Description</label>

                                    <div className="row">
                                        <div className="col" style={{
                                            backgroundColor: "#ECF0F3",
                                            paddingTop: '50px',
                                            margin: '20px 114px'
                                        }}>
                                            <ReactEditorJS onChange={data => (data.saver.save().then(desData => setDescription(desData)))} tools={EDITOR_JS_TOOLS} />
                                        </div>
                                    </div>
                                </div>

                                {/* Images */}

                                <div className="row">
                                    <div className="col">
                                        <h6>Thumbnail Image (450px x 350px)</h6>
                                        <input onChange={e => setImage(e.target.files[0])} type="file" accept='image/*' />
                                        <img className='mt-2 img-fluid' src={url} alt="" />
                                    </div>

                                    <div className="col">
                                        <h6>Service Page Image</h6>
                                        <input onChange={e => setGigImage(e.target.files[0])} type="file" accept='image/*' />
                                    </div>
                                </div>

                                <input id='form-submit' type="submit" value="Add Service" />
                            </Box>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddService;